<template>
  <div id="main">
    <div class="top-container">
      <AppHeader class="appHeader"></AppHeader>
      <router-view class="viewer" :formData="formData" @showModal="showModal"></router-view>
    </div>
    <AppFooter></AppFooter>
    <b-modal id="modalPopup" centered :title="modalTitle" ok-only>
      <div v-html="modalContent">
      </div>
    </b-modal>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';



export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  methods: {
    showModal(title, content) {
      this.modalTitle = title;
      this.modalContent = content;
      this.$bvModal.show('modalPopup');
    }
  },
  data() {
      return {

          tab1Clear: false,
          tab2Clear: false,
          formData: {
              flight: {
                  countryOfDeparture: null,
                  countryOfDepartureOthers:'',
                  flight: null,
                  frequentFlyerType:'',
                  frequentFlyerNumber:'',
                  requests:'',
                  flightItinerary: []
              },
              particulars: {
                  lastName:'',
                  firstName: '',
                  jobTitle:'',
                  department: null,
                  dateOfBirth:'',
                  nationality:'',
                  passportNo: '',
                  passportExpiry: '',
                  email:'',
                  emergencyName:'',
                  emergencyRelationship:'',
                  emergencyContact:'',
                  remarks:''
              }
          },
          modalTitle: '',
          modalContent: 'a'
      };
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      window.console.log('Modal is about to be shown', bvEvent, modalId, this.modalTitle);
    })
  }
}
</script>

<style lang="less">
#main {
	background: @grey url('assets/images/bg.jpg') no-repeat center top;
  background-size: cover;
	//min-width: 760px;
	position: relative;
  //width: 100%;  
}



#tabs {
    display: flex; 
    flex-direction: row;
    justify-content: center;
    margin: 0;

    li {
      background: none;
    }

    a {
        padding: 0.5rem 1rem;
        border-radius: 0.25rem;
        cursor: pointer;
        display: block;
        

        &:hover {
            text-decoration: none;
        }

        &:not([href]) {
          color: #007bff;
        }

        &.active {
            color: #fff;
            background-color: #007bff;
        }
        
        &.disabled {
            color: #6c757d;
            pointer-events: none;
            cursor: default;
        }
    }
}
.tab-content-container, .pageContent {
      .boxPadding();

      background: white;
      //height: calc(100vh - 240px);
      
      min-height: 494px;
      margin-top: 15px;
      margin-bottom: 15px;
      margin-left: auto;
      margin-right: auto;
      
      //max-width: 760px;
      outline: none;
      width: 100%;
      
  }
a.btn:not([href]) {
      color: #fff;
    }
a.btn-negative {
  background: #8e8e8e;
}
a.btn-negative:not([href]) {
  color: #fff;
  &:hover {
    color: #fff;
  }
}

.pageContent {
  margin-bottom: 15px;
}

.vdp-datepicker .form-control[readonly] {
  background-color: #fff;
}

form footer, .pageFooter {
        .boxPadding();
        display: flex;
        flex-direction: row;
        justify-content: center;
        
        width: 100%;

		.btn {
			margin: 0 5px;
		}
		
		i.highlight {			
			display: block;
			font-size: 0.750em;
			line-height: 0.9em;
			margin: 10px 0 0;
		}
  }
  
@media only screen and (min-width : 768px) {
  
  #main {
    .top-container {
      display: flex;
      flex-direction: column;
      height: 100vh;
      min-height: 800px;
      overflow: hidden;
    }
  }
  
  .tab-content-container, .pageContent {
    .boxPadding(2%, 2%, 2%, 2%);
    .RoundedShape(5px);
    height: calc(100vh - 280px);
    min-width:  600px;
    overflow-y: scroll;
    max-width: 760px;
  }

  form footer, .pageFooter {
    padding: 0;
  }

}

</style>
